import type { StateCreator } from 'zustand';
import type {
  BasicInfo,
  CareInfo,
  ContactDetails,
  IdentificationInfo,
  Patient,
  PatientSliceType,
  PatientState,
  RedFlagInfo,
  ResidentialAddress,
} from '../types';

export const setPatient: StateCreator<
  PatientState,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  (attributes: Partial<Patient>) => void
> = (set) => (attributes) => {
  set(
    (state) => {
      state.patient = { ...state.patient, ...attributes };
    },
    false,
    'patient/setPatient',
  );
};

export const setPatientBasicInfo: StateCreator<
  PatientSliceType,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  (attributes: Partial<BasicInfo>) => void
> = (set) => (attributes) => {
  set(
    (state) => {
      state.patient.basicInfo = { ...state.patient.basicInfo, ...attributes };
    },
    false,
    'patient/setPatientBasicInfo',
  );
};

export const setPatientCareInfo: StateCreator<
  PatientSliceType,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  (attributes: Partial<CareInfo>) => void
> = (set) => (attributes) => {
  set(
    (state) => {
      state.patient.careInfo = { ...state.patient.careInfo, ...attributes };
    },
    false,
    'patient/setPatientCareInfo',
  );
};

export const setPatientContactDetails: StateCreator<
  PatientSliceType,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  (attributes: Partial<ContactDetails>) => void
> = (set) => (attributes) => {
  set(
    (state) => {
      state.patient.contactDetails = { ...state.patient.contactDetails, ...attributes };
    },
    false,
    'patient/setPatientContactDetails',
  );
};

export const setPatientIdentificationInfo: StateCreator<
  PatientState,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  (attributes: Partial<IdentificationInfo>) => void
> = (set) => (attributes) => {
  set(
    (state) => {
      state.patient.identificationInfo = { ...state.patient.identificationInfo, ...attributes };
    },
    false,
    'patient/setPatientIdentificationInfo',
  );
};

export const setPatientRedFlagInfo: StateCreator<
  PatientState,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  (attributes: RedFlagInfo) => void
> = (set) => (attributes) => {
  set(
    (state) => {
      state.patient.redFlagInfo = { ...state.patient.redFlagInfo, ...attributes };
    },
    false,
    'patient/setPatientRedFlagInfo',
  );
};

export const setPatientIhiVerification: StateCreator<
  PatientState,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  (needsVerification: boolean) => void
> = (set) => (needsVerification) => {
  set(
    (state) => {
      state.patient.needsIhiVerification = needsVerification;
    },
    false,
    'patient/setPatientIhiVerification',
  );
};

export const setPatientResidentialAddress: StateCreator<
  PatientState,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  (attributes: ResidentialAddress) => void
> = (set) => (attributes) => {
  set(
    (state) => {
      state.patient.residentialAddress = { ...state.patient.residentialAddress, ...attributes };
    },
    false,
    'patient/setPatientResidentialAddress',
  );
};
